module.exports = "/images/icon-pdf.svg?9c0d136cb06175cfb769095b9f22741c";